import IconClose from '@/components/icons/IconClose.vue';
import ProductsCategoryFilter from '@/components/products/ProductsCategoryFilter/index.vue';

export default {
  name: 'ProductsFilters',
  components: { ProductsCategoryFilter, IconClose },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change-filters'],
  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {},
  methods: {
    onResetFilter() {
      this.$router.push({ name: this.$route.name }).catch(() => {});
    }
  }
};
